module.exports = __webpack_public_path__ + "img/applyjobs.0c6b5e14.svg";